import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightMatches',
  pure: true,
})
export class HighlightMatchesPipe implements PipeTransform {
  transform(name: string, searchTerm?: string): string {
    if (!searchTerm) {
      return escapeHtml(name);
    }

    const regex = new RegExp(`(${escapeRegex(searchTerm)})`, 'gi');
    return name
      .split(regex)
      .map((part, index) =>
        index % 2 === 1
          ? `<mark class="highlight-matches-pipe search-highlight">${escapeHtml(part)}</mark>`
          : escapeHtml(part),
      )
      .join('');
  }
}

function escapeHtml(unsafe: string): string {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function escapeRegex(unsafe: string): string {
  return unsafe.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}
